import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPublicProfile } from '../../features/publicProfile/publicProfileSlice';
import LoadingOverlay from '../../components/LoadingOverlay';
import StatusOverlay from '../../components/StatusOverlay';
import MapWithBottombarLayout from '../../components/MapWithBottombarLayout';
import JourneysMap from '../../components/JourneysMap';
import PublicProfilePanel from '../../components/public_profiles/PublicProfilePanel';
import { Box, Heading } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { getZoomForCountryCode } from '../../utilities/mappingHelper';

export default function PublicProfileSlug() {

    const { profile, isSuccess, isError, isLoading, message } = useSelector((state) => state.publicProfiles);

    const params = useParams();
    const dispatch = useDispatch();

    const displayName = params.displayName;

    useEffect(() => {
        if (!displayName) {
            return;
        }

        dispatch(getPublicProfile({ displayName }));
    }, [displayName]);

    const MyHelmet = () => (
        <Helmet>
            <title>{displayName}'s Profile | TrainLookout</title>
            <meta name="description" content={`${displayName}'s profile page`} />
            <meta name="keywords" content="profile, settings" />
            <link rel="canonical" href={`/profile/${displayName}`} />
        </Helmet>
    );

    if (isError) {
        return (<>
            <MyHelmet />
            <StatusOverlay type="modal" text={`Unable to load profile: ${message}`} hideRefresh={message === 'Network Error' ? false : true} />
        </>);
    }

    if (isLoading) {
        return (<>
            <MyHelmet />
            <LoadingOverlay type="full" text="Loading profile..." />
        </>);
    }

    if (profile) {
        return (<>
            <MyHelmet />

            <MapWithBottombarLayout
                mapComponent={
                    <JourneysMap
                        journeys={profile.mapJourneys ? profile.mapJourneys : []}
                        previewPoints={{}}

                        isImageDownloadDisabled
                        defaultCenter={getZoomForCountryCode(profile.homeCountryCode)}
                    />
                }
                bottombarComponent={
                    <>
                        <Box p="4" fontSize="sm" textAlign="center" paddingBottom={1}>
                            <Heading as="h1" size="lg">
                                <Box as="span" mr={2}>&#x1F464;</Box>
                                {displayName}
                                's profile</Heading>
                        </Box>
                        <PublicProfilePanel
                            statistics={profile.statistics}
                        />
                    </>
                }
            />
        </>);
    }
}
